<template>
  <div class="container">
    <div class="well" style="margin-top: 20px;text-align:center;padding: 50px;">
      <h1>Your complaint has been sent!</h1>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Sent',
  data () {
    return {
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Sent.vue